import { render } from "./editUserRoleForm.vue?vue&type=template&id=41511548&scoped=true"
import script from "./editUserRoleForm.vue?vue&type=script&lang=js"
export * from "./editUserRoleForm.vue?vue&type=script&lang=js"

import "./editUserRoleForm.vue?vue&type=style&index=0&id=41511548&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41511548"]])

export default __exports__